import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: '16px',
  },
  label: {
    fontSize: 14,
    color: 'grey.800',
  },
  value: {
    color: 'grey.800',
    fontSize: 16,
    fontWeight: '600',
  },
  divider: {
    backgroundColor: 'common.blue400',
    mb: '16px',
  },
  contractValue: {
    fontWeight: 700,
    color: 'primary.main',
    fontSize: 17,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
